import { MutationTree } from 'vuex'
import { State } from '.'
import { Languages } from '@/enums'

const mutations: MutationTree<any> = {
	'setUserAge'(state: State, payload: '<23' | '23+') {
		state.user.age = payload
	},
	'setUserPreferredBranches'(state: State, payload: [string, string?, string?] | 'skipped' | false) {
		state.user.preferredBranches = payload
	},
	'setCriminalRecord'(state: State, payload: 'yes' | 'no') {
		state.user.criminalRecord = payload
	},
	'setSelectedCrime'(state: State, payload: string) {
		state.user.selectedCrime = payload
	},
	'setSelectedPunishment'(state: State, payload: string) {
		state.user.selectedPunishment = payload
	},
	'setCrimeWhen'(state: State, payload: { day: number, month: number, year: number } | 'skipped' | false) {
		state.user.crimeWhen = payload
	},
	'setPunishmentWhen'(state: State, payload: { day: number, month: number, year: number } | 'skipped' | false) {
		state.user.punishmentWhen = payload
	},
	'setPunishmentLength'(state: State, payload: { amount: number, timeNotation: string } | 'skipped' | false) {
		state.user.punishmentLength = payload
	},
	'resetUser'(state: State) {
		state.user = {
			age: false,
			preferredBranches: false,
			criminalRecord: false,
			selectedCrime: false,
			selectedPunishment: false,
			crimeWhen: false,
			punishmentWhen: false,
			punishmentLength: false
		}
	},
	'setTrackResults'(state: State, payload: boolean) {
		state.trackResults = payload
	},
	'setLanguage'(state: State, payload: Languages) {
		state.language = payload
	}
}

export default mutations
